export const GET_CALENDARS = 'calendars/GET_CALENDARS'
export const GET_CALENDAR = 'calendars/GET_CALENDAR'
export const ADD_CALENDARS = 'calendars/ADD_CALENDARS'
export const EDIT_CALENDARS = 'calendars/EDIT_CALENDARS'
export const DELETE_CALENDARS = 'calendars/DELETE_CALENDARS'
export const ACTIVE_CALENDAR = 'calendars/ACTIVE_CALENDAR'
export const INACTIVE_CALENDAR = 'calendars/INACTIVE_CALENDAR'
export const START_LOADING_CALENDARS = 'calendars/START_LOADING_CALENDARS'
export const STOP_LOADING_CALENDARS = 'calendars/STOP_LOADING_CALENDARS'